import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const resp = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Session-ID": sessionId },
          credentials: "include",
        });
        if (resp.ok) setUser(await resp.json());
      } catch {}
      navigate("/", { replace: true });
    })();
  }, [location, navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="flex min-h-screen items-center justify-center bg-[#1E053B]"
    >
      <Loader2 className="h-8 w-8 animate-spin text-amber-400" />
    </div>
  );
};
